import { Users, CheckCircle, XCircle } from "lucide-react";

import { IndividualInviteCard } from "./IndividualInviteCard";
import { InvitationActionsProps } from "./types";

import { useInviteActions } from "@/components/InvitationDialogStacks/hooks/useInviteActions";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";

export const InvitationActions = ({ invites }: InvitationActionsProps) => {
  const {
    handleAccept,
    handleDecline,
    acceptAll,
    declineAll,
    isAccepting,
    isDeclining,
    isBulkAccepting,
    isBulkDeclining,
  } = useInviteActions(invites);

  const activeInvites = invites.filter(invite => !invite.is_expired);
  const isDisabled = isAccepting || isDeclining || isBulkAccepting || isBulkDeclining;

  return (
    <div className="space-y-4">
      <div className="space-y-3">
        <h4 className="flex items-center gap-2 text-sm font-medium text-gray-900">
          <Users className="h-4 w-4" />
          Active Invitations ({activeInvites.length})
        </h4>
        <div className="max-h-[300px] space-y-2 overflow-y-auto">
          {activeInvites.map(invite => (
            <IndividualInviteCard
              key={invite.id}
              invite={invite}
              onAccept={() => handleAccept(invite.id)}
              onDecline={() => handleDecline(invite.id)}
              isDisabled={isDisabled}
              isAccepting={isAccepting}
              isDeclining={isDeclining}
            />
          ))}
        </div>
      </div>

      {activeInvites.length > 1 && (
        <>
          <Separator />
          <div className="space-y-3">
            <h4 className="text-sm font-medium text-gray-900">Quick Actions</h4>
            <div className="flex gap-2">
              <Button
                variant="outline"
                onClick={declineAll}
                disabled={isDisabled}
                isLoading={isBulkDeclining}
                className="flex-1"
              >
                <XCircle className="mr-2 h-4 w-4" />
                Decline All
              </Button>
              <Button
                onClick={acceptAll}
                disabled={isDisabled}
                isLoading={isBulkAccepting}
                className="flex-1"
              >
                <CheckCircle className="mr-2 h-4 w-4" />
                Accept All
              </Button>
            </div>
          </div>
        </>
      )}
    </div>
  );
};
